import { supabaseClient } from "./config";

// Public Supabase Storage bucket used for email image assets.
// The bucket must exist and be marked "public" in the Supabase dashboard.
export const IMAGE_BUCKET = "email-assets";

const sanitize = (name = "file") =>
  name
    .toLowerCase()
    .replace(/[^a-z0-9.\-_]/g, "-")
    .replace(/-+/g, "-");

// Uploads a File to Supabase Storage and returns its public URL.
export const uploadImage = async (file) => {
  if (!file) throw new Error("No file selected.");
  if (!file.type?.startsWith("image/")) {
    throw new Error("Please choose an image file.");
  }
  // 5 MB cap keeps emails light and within most ESP limits.
  if (file.size > 5 * 1024 * 1024) {
    throw new Error("Image is larger than 5 MB.");
  }

  const path = `email-images/${Date.now()}-${sanitize(file.name)}`;

  const { error } = await supabaseClient.storage
    .from(IMAGE_BUCKET)
    .upload(path, file, {
      cacheControl: "31536000",
      upsert: false,
      contentType: file.type,
    });

  if (error) {
    throw new Error(error.message || "Upload failed.");
  }

  const { data } = supabaseClient.storage
    .from(IMAGE_BUCKET)
    .getPublicUrl(path);

  if (!data?.publicUrl) {
    throw new Error("Could not resolve public URL for the uploaded image.");
  }

  return data.publicUrl;
};
